import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'ease-out', 'EaseOut', [["path",{"d":"M3 20s10 -16 18 -16"}]]);